import { Typography } from '@mui/material';
import { useCallback } from 'react';
import { kpiTemplateAssignmentsByIdStateJ } from '../../../../../services/state/KPI/KPICompaniesStateJ';
import { kpiTemplatesMapByUuidStateJ } from '../../../../../services/state/KPI/KPITemplatesStateJ';
import { companyStateJ } from '../../../../../services/state/CompanyStateJ';
import { clientConfigFieldsAtom } from '../../../../../services/state/AppConfigStateJ';
import { useTemplateAssignmentActions } from '../hooks/useTemplateAssignmentActions';
import { ConfirmDeletionDialog } from '../../../../../components/Dialog/ConfirmDialog/ConfirmDeletionDialog';
import { allCompaniesActionStateJ, selectedAssignmentIdStateJ } from '../AllCompaniesStateJ';
import { useAllKpiCompaniesActions } from './useAllKpiCompaniesActions';
import { useAtomValue } from 'jotai';

export function DeleteAssignmentModal() {
  const id = useAtomValue(selectedAssignmentIdStateJ);
  const assignmentsMap = useAtomValue(kpiTemplateAssignmentsByIdStateJ);
  const templatesByUuid = useAtomValue(kpiTemplatesMapByUuidStateJ);
  const { companyId, templateUuid } = assignmentsMap.get(id ?? -1) ?? {};
  const company = useAtomValue(companyStateJ(companyId ?? -1));
  const template = templatesByUuid.get(templateUuid ?? '');
  const action = useAtomValue(allCompaniesActionStateJ);
  const isConsolidated =
    (useAtomValue(clientConfigFieldsAtom)?.Using_Consolidated_Data_Collection as boolean) ?? false;
  const { resetUIState } = useAllKpiCompaniesActions();
  const { deleteAssignment } = useTemplateAssignmentActions();

  const onConfirmDelete = useCallback(() => {
    if (typeof id !== 'number') {
      return;
    }
    deleteAssignment(id);
    resetUIState();
  }, [deleteAssignment, id, resetUIState]);

  if (action !== 'deleteAssignment' || typeof id !== 'number') {
    return null;
  }

  return (
    <ConfirmDeletionDialog
      open
      onClose={resetUIState}
      onConfirm={onConfirmDelete}
      title={`Delete template ${template?.name ? `"${template.name}" ` : ''}assigned to ${company?.name}?`}
    >
      <Typography
        variant='body2'
        color={'text.secondary'}
        sx={{ pt: '.25rem', minWidth: '30rem', whiteSpace: 'pre-line' }}
      >
        {isConsolidated ? ConsolidatedDeleteTemplateAssignmentWarning : DeleteTemplateAssignmentWarning}
      </Typography>
    </ConfirmDeletionDialog>
  );
}

const DeleteTemplateAssignmentWarning =
  'Any ongoing requests will be moved to "Deleted" and new requests will not be automatically created in the future.';

// Consolidated: Starbreaker only withdraws unsent drafts; sent requests stay open for the company.
const ConsolidatedDeleteTemplateAssignmentWarning =
  'No new requests will be created for this template.\nRequests that have already been sent are not affected.';
